import { IBookFromPreviousTableStrategy } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/interfaces/book-from-previous-table-strategy.interface';
import { BOOKINGS } from '@aca-new/app/pages/bookings/shared/constants/bookings.constants';
import { ESortOrder } from '@aca-new/app/shared/components/data-table/shared/models/enums/sort-order.enum';
import { IDataTableQueryParams } from '@aca-new/app/shared/components/data-table/shared/models/interfaces/data-table-query-params.interface';
import { ITableHeader } from '@aca-new/app/shared/components/table/shared/interfaces/table-header.interface';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { BOOKING_REF_NO, BOOKING_DATE, PRODUCT_NAME_MULTIPLE, REF_NO, OFFICE_LOCATION, SUPPLIER, SERVICE_TYPE } from '@aca-new/app/shared/constants/table-header.constants';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { Injectable } from '@angular/core';
import { assign, cloneDeep, pickBy } from 'lodash/index';

@Injectable()
export class LabTestingTableStrategyService implements IBookFromPreviousTableStrategy {
  public readonly userId: string = this._storageService.getItem(EStorageKeys.USER_ID);

  public tableUrlPath: string = `${SERVER_URL}/user/${this.userId}/lt/orders`;
  public tableHeaders: ITableHeader[] = [
    assign(cloneDeep(SERVICE_TYPE), { key: 'serviceType' }),
    assign(cloneDeep(BOOKING_DATE), {
      key: 'bookingDate',
      isFrontSort: true,
      width: '120',
      sortFunction(a: { label: string }, b: { label: string }, sortOrder: ESortOrder): number {
        const dateA = new Date(a.label).getTime();
        const dateB = new Date(b.label).getTime();

        return sortOrder === ESortOrder.ASC ? dateA - dateB : dateB - dateA;
      },
    }),
    assign(cloneDeep(PRODUCT_NAME_MULTIPLE), { key: 'productNames', isFrontSort: true, width: '118' }),
    assign(cloneDeep(BOOKING_REF_NO), { key: 'clientReference', isFrontSort: true, width: '120' }),
    assign(cloneDeep(REF_NO), { key: 'labOrderNo', isFrontSort: true, width: '118' }),
    assign(cloneDeep(OFFICE_LOCATION), { label: 'TABLE.TESTING_LOCATION', key: 'labLocationName', isFrontSort: true, width: '100' }),
    assign(cloneDeep(SUPPLIER), { key: 'supplierName', isFrontSort: true, width: '100' }),
  ];

  public constructor(protected readonly _storageService: StorageService) {}

  public getTableUrlParams(tableParams: IDataTableQueryParams): Record<string, string> {
    return pickBy({
      cloneType: 'reorder',
      orderStatus: BOOKINGS.LT.COPY_FROM_PREVIOUS_ORDER,
      keyword: tableParams.keyword,
      pageSize: tableParams.pageSize.toString(),
      pageNumber: tableParams.page.toString(),
    }) as Record<string, string>;
  }
}
